import { FileExtension, SortOrder } from '../general';

export interface ISharedFolderContentResponse {
  folderId: string;
  folderName: string;
  documents: [ISharedDocumentsResponse];
  folders: [ISharedFoldersResponse];
  breadcrumbs: [ISharedFolderContentBreadcrumb];
  shouldSeeMigrationModal: boolean;
}

export interface ISharedDocumentsResponse {
  id: string;
  name: string;
  extension: FileExtension;
  sharedWithMeAt: string;
  unread: boolean;
}

export interface ISharedFolderContentBreadcrumb {
  id: string;
  name: string;
}

export interface ISharedFoldersResponse {
  id: string;
  name: string;
  unreadDocumentCount: number;
}

export interface IUnreadResponse {
  documents: boolean;
  // Optional: the backend / older responses may omit it, and all consumers guard with `?.`.
  ticketsWithUnreadMessages?: ITicketsWithUnreadMessages;
  unreadDocuments?: IUnreadContracts;
  unreadTicketMessages?: IUnreadTicketMessages;
}

export interface ITicketsWithUnreadMessages {
  damage: number;
  concern: number;
}

// `contractless` means the unread items are not bound to a contract, so every contract is affected.
export interface IUnreadContracts {
  contractIds: string[];
  contractless: boolean;
}

export interface IUnreadTicketMessages extends IUnreadContracts {
  archivedContractIds: string[];
  archivedContractless: boolean;
}

export interface ISharedContentParams {
  folderId?: string | null;
  contractId?: string | null;
  sortOrder?: SortOrder | null;
  sortField?: DocumentSortField | null;
}

export enum DocumentSortField {
  NAME = 'NAME',
  SHARED_WITH_ME_DATE = 'SHARED_WITH_ME_DATE',
}

export enum DocumentStatus {
  DOCUMENT_REQUESTED = 'DOCUMENT_REQUESTED',
  DOCUMENT_ALREADY_REQUESTED = 'DOCUMENT_ALREADY_REQUESTED',
  DOCUMENT_UNAVAILABLE = 'DOCUMENT_UNAVAILABLE',
}

export const DocumentStatusHeader = {
  get: (isIOS: boolean): string => (isIOS ? 'x-document-status' : 'X-Document-Status'),
};

export enum TicketAttachmentStatus {
  TICKET_ATTACHMENT_REQUESTED = 'TICKET_ATTACHMENT_REQUESTED',
  TICKET_ATTACHMENT_ALREADY_REQUESTED = 'TICKET_ATTACHMENT_ALREADY_REQUESTED',
  TICKET_ATTACHMENT_UNAVAILABLE = 'TICKET_ATTACHMENT_UNAVAILABLE',
}

export const TicketAttachmentStatusHeader = {
  get: (isIOS: boolean): string =>
    isIOS ? 'x-ticket-attachment-status' : 'X-Ticket-Attachment-Status',
};

export interface IAttachmentResponse<TFile = unknown> {
  file: TFile | null;
  header: TicketAttachmentStatus | null;
}
